import myAxios from "./axiosWrapper";
import getConfig from "../conf/config";

export const downloadCallAudioBlob = async (callId) => {
  if (!callId) {
    throw new Error("Missing call id for audio download.");
  }
  const response = await myAxios.get(
    `${getConfig().API_URL}/audio/api/v1/calls/audio_download/${callId}`,
    { responseType: "blob" }
  );
  return response.data;
};
